<template>
  <div class="col-12 col-md-12 col-lg-8 text-center">
    <div class="tit">
      <p>Balanço e DRE do último exercício assinado pelo contador</p>
    </div>
    <form>
      <div class="margin">
        <files-input :files="arquivos" :accept="formatosAceitos"
          :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
      </div>
      <div class="margin">
        <div class="form-check d-flex justify-content-center">
          <div class="checkboxContainer">
            <input v-model="naoPossuiBalancoEDre" type="checkbox"/>
            <span class="checkmark"></span>
          </div>
          <label class="form-check-label" for="exCheck01">Não possuo o balanço e DRE da minha empresa</label>
        </div>
      </div>
      <div class="text-center fixedOptions">
        <button @click="onSubmit" class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
  .margin {
    margin-bottom: 25px;
  }

  p.files {
    font-size: 12px!important;
    padding: 20px 0;
  }
</style>

<script>
import FilesInput from '@/components/FilesInput'
import ArrayHelper from '@/utils/array-helper'

export default {
  components: {
    FilesInput
  },
  data() {
    return {
      /* eslint-disable */  
      uploadEndpoint: process.env.API_NODE+'/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: this.solicitacao.ArquivosBalancoEDre || [],
      naoPossuiBalancoEDre: false
    }
  },
  computed: {
    arquivosRecebidos: function() {
      return this.arquivos.filter(arquivo => {
        return arquivo != null && arquivo != undefined
      })
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles
    },
    validate() {
      if(this.arquivosRecebidos.length > 0 || this.naoPossuiBalancoEDre) {
        return {isValid: true, errors: []}
      } else {
        return {isValid: false, errors: ['O envio do Balanço e DRE é obrigatório']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      const validation = this.validate()
      
      if(validation.isValid) {
        const newData = {
          ArquivosBalancoEDre: this.arquivosRecebidos,
          NaoPossuiBalancoEDre: this.naoPossuiBalancoEDre
        }
        this.$emit('on-submit', newData)
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/EnvioBalancoDrePasso.vue